module.exports = __webpack_public_path__ + "static/media/Fotograf-Krym-YAlta.321f63da.jpg";